module.exports = __webpack_public_path__ + "static/media/icon-help.852dfa75.svg";